import Circle_Write from "../../components/ExcerciseTypes/Circle_Write";
import T6v2 from "../../components/ExcerciseTypes/TypeIn/T6v2";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";

const json = {
  1: {
    unit: "Unit 1",
    id: "FP8-WB-demo-2023-U1-P12-E1",
    // audio: "/Audios/1-04 Friends Plus 8_WB.mp3",
    video: "",
    component: T6v2,
    inputSize:350,
    textAlign:'center',
    exerciseKey: "/img/FriendsPlus/Page13/Key/E1answerKey.jpg",
    titleQuestion: [
      {
        title: ` <div style= "background-color: rgb(108,207,151); border-radius: 50%; color: white; width: 39px; text-align: center; margin-right: 15px">1</div>
        <div style= "display: flex;
        margin-left: 50px;
        margin-top: -35px;">
        <div style= "background-color:">Con ong bay đến bông hoa màu nào nếu:</div>
      </div>`
      },
    ],
    questions: [
      {
        title: `
        <img src="/img/FriendsPlus/Page13/E1/1.jpg" Style='width:70%;margin-left:100px' >
        <div style='line-height:3.5;margin-left:40px;margin-top:10px'>
        <div> <b>a) Con ong bay theo đường ghi các số chẵn?</b> #</div>

        <div> <b>b) Con ong bay theo đường ghi các số lẻ?</b> #</div>
        
        </div>
        `,
        answer: [
          `bông hoa xanh lam`,`bông hoa vàng`,
        ],
      },
    ],
  },
  2: {
    unit: "Unit 1",
    id: "FP8-WB-demo-2023-U1-P12-E1",
    // audio: "/Audios/1-04 Friends Plus 8_WB.mp3",
    video: "",
    component: T6v2,
    inputSize:62,
    maxLength: 3,
    isHiddenCheck:true,
    stylesTextInput: {
      background: 'transparent',
      border: 'none',
      fontSize: "25px",
      textAlign:'center'
    },
    textAlign:'center',
    exerciseKey: "/img/FriendsPlus/Page13/Key/E2answerKey.png",
    titleQuestion: [
      {
        title: ` <div style= "background-color: rgb(108,207,151); border-radius: 50%; color: white; width: 39px; text-align: center; margin-right: 15px">2</div>
        <div style= "display: flex;
        margin-left: 50px;
        margin-top: -35px;">
        <div style= "background-color:">Nêu số nhà còn thiếu.</div>
      </div>`
      },
    ],
    questions: [
      {
        title: `
        
        <div style='margin-top:10px;display:flex'>
        <div>
        <div style='margin-top: 40px'> <b>a) Bên dãy số chẵn:</b> </div>

        <div style='margin-top: 40px'> <b>b) Bên dãy số lẻ:</b> </div>
        </div>
        <div style='position: relative;'>
							<div style='display:flex'>
									<img src="/img/FriendsPlus/Page13/E2/1.jpg" style='width:70%;margin-left:20px' >
							</div>
          		<div style="  position: absolute; top: 32px; left: 207px; "><input id='0' style="width:0px"></input></div>
          		<div style="  position: absolute; top: 32px; left: 297px; "><input id='1' style="width:0px"></input></div>
          		<div style="  position: absolute; top: 32px; left: 389px; "><input id='2' style="width:0px"></input></div>
          		<div style="  position: absolute; top: 111px; left: 206px; "><input id='3' style="width:0px"></input></div>
          		<div style="  position: absolute; top: 111px; left: 297px; "><input id='4' style="width:0px"></input></div>
          		<div style="  position: absolute; top: 111px; left: 389px; "><input id='5' style="width:0px"></input></div>
						</div>
        </div>
        `,
        answer: [
         `120`,`122`,`124`,
         `121`,`123`,`125`,
        ],
      },
    ],
  },
  3: {
    unit: "Unit 1",
    id: "FP8-WB-demo-2023-U1-P13-E3",
    audio: "",
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page13/Key/E3answerKey.jpg",
    component: T6v2,
    maxLength: 2,
    inputSize: 200,
    stylesTextInput: {
			// borderStyle: 'dashed',
			borderWidth: 1,
        borderColor: 'rgb(253,206,125)',
        width: 50,
        height: 50,
        justifyContent: 'center',
        alignItems: 'center',
			fontSize: '22px',
			textAlign: 'center',
		},
    titleQuestion: [
      {
        title: `<div style= "background-color: rgb(108,207,151); border-radius: 50%; color: white; width: 39px; text-align: center; margin-right: 15px">3</div>
       `,
      },
    ],
    questionImage: [],
    // hideBtnFooter: true,
    isHiddenCheck: true,
    questions: [
      {
        title: `
        <div style='margin-left: 50px;margin-top: -57px;'> 
          <div style='line-height:2.5'>
            <div style='display:flex'>a)&ensp;<div style= "background-color: rgb(253,206,125);height:50px; border-radius: 5px; width: 50px; text-align: center">Số</div> ?</div>
            <ul>
              <li>Biết 116 và 118 là hai số chẵn liên tiếp. Hai số chẵn liên tiếp hơn kém nhau # đơn vị.</li>
              <li>Biết 116 và 118 là hai số chẵn liên tiếp. Hai số lẻ liên tiếp hơn kém nhau # đơn vị.</li>
            </ul>
          </div>
          <div style='line-height:2.5'>
            <div style='display:flex'>b)<ul style='margin-left:-30px'>
            <li style='display:flex'>• Nêu các số chẵn để được ba số chẵn liên tiếp: <span style='border:1px solid rgb(253,206,125);width:50px;height:50px; justify-content:center;display:flex;align-items:center'>78</span> # #</li>
            <li style='display:flex'>• Nêu các số lẻ để được ba số lẻ liên tiếp: <span style='border:1px solid rgb(253,206,125);width:50px;height:50px;justify-content:center;display:flex;align-items:center'>67</span> # #</li>
          </ul></div>
            
         </div>
        </div>
        `,
        answer: [
         `2`,`2`,`80`,`82`,`69`,`71`,
        ],
      },
    ],
  },
  4: {
    unit: "Unit 1",
    id: "FP8-WB-demo-2023-U1-P13-E4",
    audio: "",
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page13/Key/E4answerKey.jpg",
    component: T6,
    // maxLength: 1,
    inputSize: 300,
    stylesTextInput: {
      // background: 'transparent',
      border: 'none',
      fontSize: "24px",
      textAlign:'center'
    },
    titleQuestion: [
      {
     
        title: `
        <div style='display:flex'>
        <div style= "background-color:rgb(108,207,151); border-radius: 50%; color: white; width: 39px; text-align: center; margin-right: 15px">4</div>
        </div>`,
        
      },
    ],
    questionImage: [],
    // hideBtnFooter: true,
    isHiddenCheck: true,
    questions: [
      {
        title: `
        <div style='margin-left: 40px;margin-top:-45px;'>
        <div style= "display:flex"> Từ hai trong ba thẻ số&ensp;<span style= "background-color: rgb(253,206,125);height:50px; border-radius: 5px;margin-top:-10px; width: 35px; justify-content:center;display:flex;align-items:center">7</span>,
        <span style= "background-color: rgb(253,206,125);height:50px; border-radius: 5px; width: 35px;margin-top:-10px; justify-content:center;display:flex;align-items:center">4</span>,
        <span style= "background-color: rgb(253,206,125);height:50px; border-radius: 5px; width: 35px;margin-top:-10px; justify-content:center;display:flex;align-items:center">5</span>, hãy lập tất cả các số chẵn và các số lẻ có hai chữ số.</div>
        </div>


        <table style= "margin-top: 19px; margin-left:200px;margin-top:40px;text-align: center; font-size: 22px" border= "1">
  
        <tr style= "background-color: rgb(248,230,173)">
          <th style= "width: 300px">Số Chẵn</th>
          <th style= "width: 300px">Số Lẻ</th>
        </tr>

        <tr>
          <td><input id= "0"></td>
          <td><input id= "1"></td>
        </tr>
      </table>
        `,
        answer: [
          `54, 74 / 74, 54`, 
           `45, 47, 75, 57 / 45, 57, 47, 75 / 45, 57, 75, 47 / 45, 75, 47, 57 / 45, 75, 57, 47 / 47, 45, 57, 75 / 47, 45, 75, 57 / 47, 57, 45, 75 / 47, 57, 75, 45 / 47, 75, 45, 57 / 47, 75, 57, 45 / 57, 45, 47, 75 / 57, 45, 75, 47 / 57, 47, 45, 75 / 57, 47, 75, 45 / 57, 75, 45, 47 / 57, 75, 47, 45 / 75, 45, 47, 57 / 75, 45, 57, 47 / 75, 47, 45, 57 / 75, 47, 57, 45 / 75, 57, 45, 47 / 75, 57, 47, 45 `
        ],
      },
    ],
  },
  5: {
    unit: "Unit 1",
    id: "FP8-WB-demo-2023-U1-P12-E1",
    // audio: "/Audios/1-04 Friends Plus 8_WB.mp3",
    video: "",
    component: T6v2,
    inputSize:62,
    // maxLength: 3,
    textareaStyle:{width:300, fontSize: "27px",},
    isHiddenCheck:true,
    stylesTextInput: {
      background: 'transparent',
      border: 'none',
      fontSize: "25px",
      textAlign:'center'
    },
    textAlign:'center',
    exerciseKey: "/img/FriendsPlus/Page13/Key/E5answerKey.jpg",
    titleQuestion: [
      {
        title: ` <div style= "background-color: rgb(108,207,151); border-radius: 50%; color: white; width: 39px; text-align: center; margin-right: 15px">2</div>
        <div style= "display: flex;
        margin-left: 50px;
        margin-top: -35px;">
        <div style= "background-color:">Nêu các số chẵn, số lẻ trên thanh tia số dưới đây, theo thứ tự từ nhỏ đến lớn.</div>
      </div>`
      },
    ],
    questions: [
      {
        title: `
    	<img src="/img/FriendsPlus/Page13/E5/1.jpg" style='width:100%;' >
      <table style= "margin-top: 19px; margin-left:200px;margin-top:40px;text-align: center; font-size: 22px" border= "1">
  
        <tr style= "background-color: rgb(248,230,173)">
          <th style= "width: 300px">Số Chẵn</th>
          <th style= "width: 300px">Số Lẻ</th>
        </tr>

        <tr>
          <td><textarea id='0' rows='2'></textarea></td>
          <td><textarea id='1' rows='2'></textarea></td>
        </tr>
      </table>
							
        `,
        answer: [
         `2, 4, 6, 8, 10, 12`,




         `1, 3, 5, 7, 9, 11`,
        ],
      },
    ],
  },
  6: {
    unit: "Unit 1",
    id: "FP8-WB-demo-2023-U1-P12-E1",
    // audio: "/Audios/1-04 Friends Plus 8_WB.mp3",
    video: "",
    component: T6v2,
    inputSize:62,
    maxLength: 3,
    isHiddenCheck:true,
    textareaStyle:{width:800},
    stylesTextInput: {
      background: 'transparent',
      border: 'none',
      fontSize: "25px",
      textAlign:'center'
    },
    textAlign:'center',
    exerciseKey: "/img/FriendsPlus/Page13/Key/E2answerKey.jpg",
    titleQuestion: [
      {
        title: ` <div style= "background-color: rgb(108,207,151); border-radius: 50%; color: white; width: 39px; text-align: center; margin-right: 15px">3</div>
        <div style= "display: flex;
        margin-left: 50px;
        margin-top: -35px;">
        <div style= "background-color:">Từ 10 đến 31 có bao nhiêu số chẵn, bao nhiêu số lẻ?</div>
      </div>`
      },
    ],
    questions: [
      {
        title: `
        <div  style='margin-top:30px' >
        <div style='margin-left:350px'><u><i><b>Bài Giải:</b></i></u></div>
          <div  style='margin-left:0px'> <textarea id='0' rows='3'></textarea></div>
            
        </div>		
        `,
        answer: [
         `120`,`122`,`124`,
         `121`,`123`,`125`,
        ],
      },
    ],
  },
};

export default json;
